import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { composeRenderProps } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
import { Modal } from '../Modal/Modal.js';
/**
 * Renders a dialog as a modal, trapping focus and providing a backdrop.
 *
 * @example
 * ```tsx
 * <DialogModal>
 *   <Dialog>
 *     <DialogHeader>
 *       <DialogTitle>This is a modal dialog</DialogTitle>
 *       <OverlayCloseButton label="Close" />
 *     </DialogHeader>
 *     <DialogBody>
 *       <Text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
 *     </DialogBody>
 *   </Dialog>
 * </DialogModal>
 * ```
 */
export const DialogModal = forwardRef(function DialogModal({ size = 'default', className, overlayClassName, ...modalProps }, forwardedRef) {
    return (_jsx(Modal, { ...modalProps, ref: forwardedRef, overlayClassName: composeRenderProps(overlayClassName, (className) => twMerge('flex items-center justify-center', className)), className: composeRenderProps(className, (className) => twMerge('ppl-DialogModal max-h-[90vh] overflow-hidden rounded border border-default shadow-lg', 'entering:animate-in entering:fade-in entering:zoom-in exiting:animate-out exiting:fade-out exiting:zoom-out', {
            small: 'w-[min(378px,95vw)]',
            default: 'w-[min(552px,95vw)]',
            large: 'w-[min(736px,95vw)]',
        }[size], className)) }));
});
//# sourceMappingURL=DialogModal.js.map